import { Dialog, DialogActions, DialogContent, DialogTitle, Button, RadioGroup, FormControlLabel, Radio, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from "react-i18next";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import "../../css/main.css";
import { green, red } from '@mui/material/colors';

export default function EncryptFileModal({ openEncryptFileModal, handleEncryptFileModalClose, handleFileEncryption, avoidMisfire }) {
    const { t } = useTranslation();
    const [encryptOption, setEncryptOption] = useState('no'); 

    const handleEncryptOptionChange = (event) => {
        setEncryptOption(event.target.value);
    };

    const handleConfirm = () => {
        handleFileEncryption(encryptOption === 'yes'); 
        handleEncryptFileModalClose();
    };

    return (
        <Dialog open={openEncryptFileModal} onClose={handleEncryptFileModalClose} className="modal-background-color">
            <DialogTitle>
                {t("modal.encrypt_file")}
            </DialogTitle>
            <DialogContent className="white-txt-color">
                <Typography>{t("modal.encrypt_file_question")}</Typography>
                <RadioGroup
                    aria-label="encrypt-file"
                    name="encrypt-file"
                    value={encryptOption}
                    onChange={handleEncryptOptionChange}
                    className="radio-group"
                >
                    <FormControlLabel 
                        value="yes" 
                        control={
                            <Radio
                                sx={{
                                    color: green[500],
                                    '&.Mui-checked': {
                                        color: green[600],
                                    },
                                }}
                            />
                        } 
                        label={
                            <div className="flex-row-center">
                                <LockIcon style={{ color: green[600], marginRight: 8 }} />
                                <span>{t("modal.encrypt_yes")}</span>
                            </div>
                        } 
                    />
                    <FormControlLabel 
                        value="no" 
                        control={
                            <Radio
                                sx={{
                                    color: red[500],
                                    '&.Mui-checked': {
                                        color: red[600],
                                    },
                                }}
                            />
                        } 
                        label={
                            <div className="flex-row-center">
                                <LockOpenIcon style={{ color: red[600], marginRight: 8 }} />
                                <span>{t("modal.encrypt_no")}</span>
                            </div>
                        } 
                    />
                </RadioGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleEncryptFileModalClose} className="decline-button">
                    <CancelIcon style={{ marginRight: 4 }} />
                    <span className="button-text">
                    {t("global.cancel")}
                    </span>
                </Button>
                <Button onClick={handleConfirm} disabled={avoidMisfire} className="accept-button">
                    <CheckCircleIcon style={{ marginRight: 4 }} />
                    <span className="button-text">
                    {t("modal.confirm")}
                    </span>
                </Button>
            </DialogActions>
        </Dialog>
    );
}
